import { schoolConstants } from './constants';
import Cookies from 'universal-cookie';


var viewActions = require ('../../store/view.actions');

var schoolService = require ('./api');

export const schoolActions = {
    getSchoolCalendarLevels, getSchoolLevel, getSchoolLevelCourses, setCurrentCalendar, changeCurrentCalendar,
    getEnrollFile, deleteEnrollFile, uploadEnrollFile,
    enrollStudentCourse
};  


function  enrollStudentCourse (  token, personaID, calendarID, courseID ) { 
    return dispatch => {
           
            dispatch(viewActions.isLoadingModule('enrollStudentCourse',true)) ;

            schoolService.enrollStudentCourse ( token, personaID, calendarID, courseID )
                .then( json => {
                    dispatch({
                        type: schoolConstants.ENROLL_STUDENT_COURSE,
                        currentCourse: json
                      }) 
                    dispatch(viewActions.isLoadingModule('enrollStudentCourse',false) )
                } )
            
    }
  }


function  uploadEnrollFile ( token, personaID, calendarID, reqID, data ) { 
    return dispatch => {
           
            dispatch(viewActions.isLoadingModule('uploadEnrollFile',true)) ;
            dispatch(viewActions.isLoadingModule('uploadOK',false) )
            schoolService.uploadEnrollFile ( token, personaID, calendarID, reqID, data  )
                .then( json => {
                    dispatch( getEnrollFile ( token, personaID, calendarID ) );
                    dispatch(viewActions.isLoadingModule('uploadEnrollFile',false) )
                    dispatch(viewActions.isLoadingModule('uploadOK',true) )
                } )
            
    }
  }


function  deleteEnrollFile ( token, personaID, calendarID, reqID, fileID  ) { 
    return dispatch => {
           
            dispatch(viewActions.isLoadingModule('deleteEnrollFile'+fileID,true)) ;
            schoolService.deleteEnrollFile ( token, personaID, reqID, fileID )
                .then( json => {
                    dispatch( getEnrollFile ( token, personaID, calendarID ) );
                    dispatch(viewActions.isLoadingModule('deleteEnrollFile'+fileID,false) )
                } )
            
    }
  }

function  getEnrollFile ( token, personaID, calendarID ) { 
    return dispatch => {
           
            dispatch(viewActions.isLoadingModule('getEnrollFile',true)) ;
            schoolService.getEnrollFile( token, personaID, calendarID )

            .then( json => {
                dispatch({
                  type: schoolConstants.LOAD_ENROLL_FILE,
                  enrollFile: json
                })  
              
                dispatch(viewActions.isLoadingModule('getEnrollFile',false) )
            } )
            
    }
  }

function setCurrentCalendar(calendarID) {
    return {
        type: schoolConstants.SET_CURRENT_CALENDAR,
        currentCalendarID: calendarID
    }
    }

function changeCurrentCalendar(calendarID) {
    let cookies = new Cookies() ;
    cookies.set('calID', calendarID, { path: '/' }) ;
    window.location.reload();
    // return {
    //     type: schoolConstants.SET_CURRENT_CALENDAR,
    //     currentCalendarID: calendarID
    // }
    }
    


function getSchoolCalendarLevels( calendarID ) {
    return dispatch => {
            dispatch(viewActions.isLoading(true)) ;
         
            schoolService.getSchoolCalendarLevels( calendarID )
            .then( json => {
                dispatch(showSchoolCalendarLevels( json))
                dispatch(viewActions.isLoading(false) )
            } )
            
    }
  }

function getSchoolLevel( levelID ) {
    return dispatch => {
            dispatch(viewActions.isLoading(true)) ;
            
            schoolService.getSchoolLevel( levelID )
            .then( json => {
                if (json.level.type_id === "1") {
                   dispatch( { type: schoolConstants.CLEAN_LEVELS }) ;
                }
                dispatch(showSchoolLevel(json))
                dispatch(viewActions.isLoading(false) )
            } )
    }
}

function getSchoolLevelCourses( levelID ) {
    return dispatch => {
            dispatch(viewActions.isLoading(true)) ;
            
            schoolService.getSchoolLevelCourses( levelID )
            .then( json => {
                dispatch(showSchoolLevelCourses(json))
                dispatch(viewActions.isLoading(false) )
            } )
    }
}


function showSchoolLevel(json) {
    let lvl = (json.levelChilds[0]?json.levelChilds[0].type_id: "1") ;
    let theType = (lvl==="2"?schoolConstants.SHOW_LEVEL_2:schoolConstants.SHOW_LEVEL_3) ;
    let clean = (json.levelChilds[0].type_id === "3" && json.level.type_id === "1") ;
    return {
        type: theType,
        clean: clean,
        levelChilds: json.levelChilds,
        level: json.level
    }
}

function showSchoolLevelCourses(json) {
    return {
      type: schoolConstants.SHOW_LEVEL_COURSES,
      levelCourses: json
    }
  }

function showSchoolCalendarLevels(json) {
    return {
      type: schoolConstants.SHOW_CALENDAR_LEVELS,
      calendarLevels: json
    }
  }
